/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1SoftcoverpapersQueryResponse } from '../../types/GetV1Softcoverpapers.ts'

export const getV1SoftcoverpapersQueryKey = () => [{ url: '/v1/SoftCoverPapers' }] as const

export type GetV1SoftcoverpapersQueryKey = ReturnType<typeof getV1SoftcoverpapersQueryKey>

/**
 * {@link /v1/SoftCoverPapers}
 */
export async function getV1Softcoverpapers(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1SoftcoverpapersQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/SoftCoverPapers`, ...requestConfig })
    return res
}

export function getV1SoftcoverpapersQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1SoftcoverpapersQueryKey()
    return queryOptions<
        ResponseConfig<GetV1SoftcoverpapersQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1SoftcoverpapersQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Softcoverpapers(config)
        },
    })
}

/**
 * {@link /v1/SoftCoverPapers}
 */
export function useGetV1Softcoverpapers<
    TData = ResponseConfig<GetV1SoftcoverpapersQueryResponse>,
    TQueryData = ResponseConfig<GetV1SoftcoverpapersQueryResponse>,
    TQueryKey extends QueryKey = GetV1SoftcoverpapersQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1SoftcoverpapersQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1SoftcoverpapersQueryKey()

    const query = useQuery(
        {
            ...getV1SoftcoverpapersQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
